<template>
    <div
        class="store-locator-container d-flex flex-column justify-stretch"
        :class="{
            'full-screen': isMapExpanded,
            'mb-16': !isMobile && !isMapExpanded,
            'text-grey-lighten-4': isMapExpanded
        }"
    >
        <Form ref="elFormObj" as="" v-slot="{ errors: formErrors, meta: formMeta, resetForm }" :initial-values="form">
            <form
                @submit="onSubmit($event)"
                @reset="onReset($event)"
                class="mb-4"
                novalidate
            >
                <v-expansion-panels v-model="panelSearchBox">
                    <v-expansion-panel>
                        <v-expansion-panel-title
                            class="font-weight-bold"
                            static
                        >
                            Search Map
                        </v-expansion-panel-title>
                        <v-expansion-panel-text
                            class="pt-3"
                        >
                            <v-row dense>
                                <!-- Label
                                <v-col cols="12" md="2" class="d-flex align-center justify-md-end">
                                    <label>Find store within:</label>
                                </v-col>
                                -->

                                <!-- Radius -->
                                <v-col cols="6" sm="3">
                                    <Field
                                        name="itemRadius"
                                        label="Radius"
                                        v-slot="{ field, errors }"
                                        v-model="form.radius"
                                        rules="required"
                                    >
                                        <v-select
                                            v-bind="field"
                                            :model-value="field.value"
                                            name="itemRadius"
                                            label="Radius"
                                            :items="itemsRadius"
                                            item-title="text"
                                            variant="outlined"
                                            hide-details
                                            density="compact"
                                        ></v-select>
                                    </Field>
                                </v-col>

                                <!-- Unit -->
                                <v-col cols="6" sm="3">
                                    <Field
                                        name="unit"
                                        label="Unit"
                                        v-slot="{ field, errors }"
                                        v-model="form.unit"
                                        rules="required"
                                    >
                                        <v-select
                                            v-bind="field"
                                            :model-value="field.value"
                                            name="unit"
                                            label="Unit"
                                            item-title="text"
                                            :items="itemsUnit"
                                            variant="outlined"
                                            hide-details
                                            density="compact"
                                        ></v-select>
                                    </Field>
                                </v-col>

                                <!-- Location -->
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="form.location"
                                        name="location"
                                        label="Location"
                                        variant="outlined"
                                        hide-details
                                        density="compact"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <!-- Submit / Reset -->
                                <v-col cols="12" class="d-flex justify-end">
                                    <div class="action-buttons d-flex">
                                        <v-btn
                                            class="flex-shrink-0 flex-grow-1"
                                            color="primary"
                                            type="submit"
                                            :disabled="!lo_isEmpty(formErrors)"
                                        >
                                            Search
                                        </v-btn>
                                        <v-btn
                                            class="flex-shrink-1 flex-grow-0"
                                            color="secondary"
                                            type="reset"
                                            :disabled="!lo_isEmpty(formErrors)"
                                        >
                                            Reset
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </form>
        </Form>

        <div
            class="map-panel d-flex flex-column fill-height"
        >
            <v-toolbar
                class="mb-0 flex-grow-0"
                elevation="0"
                density="compact"
            >
                <v-btn
                    color="secondary"
                    @click="retailerListPanel = !retailerListPanel"
                    class="show-list-btn"
                    :ripple="false"
                    variant="text"
                    aria-label="Show/Hide List"
                >
                    <v-icon class="mr-2" :icon="mdiFormatListBulletedSquare"></v-icon>
                    <template v-if="!isMobile">
                        <span v-if="retailerListPanel">Hide</span>
                        <span v-else>Show</span>
                        &nbsp;List
                    </template>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="secondary"
                    @click="toggleFullScreen()"
                    class="toggle-fullscreen-btn"
                    :ripple="false"
                    variant="text"
                    aria-label="Toggle Fullscreen"
                    :aria-expanded="isMapExpanded"
                >
                    <template v-if="!isMapExpanded">
                        <v-icon class="mr-2" :icon="mdiArrowExpandAll"></v-icon>
                        <template v-if="!isMobile">Expand Map</template>
                    </template>
                    <template v-else>
                        <v-icon class="mr-2" :icon="mdiArrowCollapseAll"></v-icon>
                        <template v-if="!isMobile">Return</template>
                    </template>
                </v-btn>
            </v-toolbar>

            <div
                class="position-relative overflow-hidden flex-grow-1 flex-shrink-0 rounded-t-0"
            >
                <v-navigation-drawer
                    v-model="retailerListPanel"
                    width="320"
                    location="left"
                    :scrim="false"
                    absolute
                    temporary
                >
                    <template #prepend>
                        <div class="py-2 position-relative">
                            <div class="text-center font-weight-bold">
                                <!-- TODO: Consider showing error if items don't load? -->
                                <span
                                    v-if="isFiltering"
                                >
                                    Showing {{ filteredLocationsCount }} of
                                </span>
                                <span>{{ locationsCount }} stores</span>

                                <v-btn
                                    v-if="isFiltering"
                                    :icon="mdiFilterRemove"
                                    color="secondary"
                                    variant="plain"
                                    size="small"
                                    @click="onReset($event)"
                                >
                                </v-btn>
                            </div>
                            <v-text-field
                                placeholder="Filter Stores"
                                v-model="retailLocationsFilter"
                                class="ma-4 white"
                                variant="outlined"
                                density="compact"
                                hide-details
                                clearable
                            ></v-text-field>
                            <v-btn
                                @click="retailerListPanel = false"
                                class="ma-auto position-absolute"
                                style="top: 0; right: 0;"
                                variant="plain"
                                size="small"
                                color="secondary"
                                :ripple="false"
                                aria-label="Close Retailer List"
                                :icon="mdiWindowClose"
                            >
                            </v-btn>
                        </div>
                    </template>
                    <template #default>
                        <v-virtual-scroll
                            v-if="!lo_isError(retailLocations) && locationsCount > 0"
                            class="list-retailers"
                            :items="retailLocationsFiltered"
                            height="100%"
                            item-height="180"
                        >
                            <template #default="{ item, index }">
                                <v-list-item :key="item.uid">
                                    <template v-if="item.address">
                                        <v-list-item-title>
                                            <strong>{{ item.address.company }}</strong>
                                        </v-list-item-title>
                                        <address class="text-body-1">
                                            {{ item.address.street1 }}
                                            <br />
                                            <template v-if="item.address.street2">
                                                {{ item.address.street2 }}
                                                <br />
                                            </template>
                                            {{ item.address.city }} {{ item.address.state }}, {{ item.address.postalCode }}
                                            <br />
                                            {{ item.address.country }}
                                        </address>
                                    </template>
                                    <template #append>
                                        <v-btn @click="locationItemClick(item)" variant="plain" icon>
                                            <v-icon color="secondary" :icon="mdiMapMarkerRight"></v-icon>
                                        </v-btn>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-virtual-scroll>
                    </template>
                </v-navigation-drawer>
                <client-only>
                    <LocationsMap
                        ref="elLocationsMap"
                        class="cmp-address-map fill-available-height"
                        :height="mapHeight"
                        :locations="retailLocations"
                        :search="searchObj"
                        @on-bound-locations="onBoundLocations($event)"
                        @location-search-error="showLocationSearchError()"
                    ></LocationsMap>
                </client-only>
            </div>
        </div>

        <DebugContent>
            <div class="py-4">
                <v-btn @click="getRetailLocations()" color="primary" small>Reload Locations</v-btn>
            </div>
        </DebugContent>
    </div>
</template>

<script lang="ts" setup>
    import type { Field, Form } from 'vee-validate';
    import LocationsMap from '~/components/LocationsMap/LocationsMap.vue';
    import type { LocationsMapSearch, SelectListItem, Location } from '~/types';
    import { LocationsMapSearchModel } from '~/models';
    import { useGlobalAlert, useLocations, useUiState, useIsMobile } from '~/composables';
    import { isError as lo_isError } from 'es-toolkit';
    import { isNil as lo_isNil } from 'es-toolkit';
    
    import { merge as lo_mergeCompat } from 'es-toolkit/compat';
    import { isEmpty as lo_isEmpty } from 'es-toolkit/compat';
    import DebugContent from '~/components/DebugContent/DebugContent.vue';
    import { VVirtualScroll } from 'vuetify/components/VVirtualScroll';
    import {
        mdiFormatListBulletedSquare,
        mdiArrowExpandAll,
        mdiArrowCollapseAll,
        mdiMapMarkerRight,
        mdiWindowClose,
        mdiFilterRemove
    } from '@mdi/js';
    import { useDisplay } from 'vuetify';
    import { debouncedWatch } from '@vueuse/core'
    import { initVeeRules } from '~/helpers/forms';
    import { getSingleParam } from 'x1-base/utils';
    
    import type { WatchStopHandle } from 'vue';

    initVeeRules([ 'required' ]);

    const elFormObj = shallowRef<typeof Form>();
    const retailerListPanel = ref(false);
    const elLocationsMap = shallowRef<InstanceType<typeof LocationsMap>>();
    const route = useRoute();
    const createGlobalAlert = useGlobalAlert();
    const useLocationsObj = useLocations();
    const useUiStateObj = useUiState();
    const { isMobile } = useIsMobile();
    const isMapExpanded = ref(false);
    const useDisplayObj = useDisplay();

    const retailLocationsFiltered = ref<Location[]>([]);
    const retailLocationsFilter = ref<string>('');
    const boundLocationsUids = ref<string[]>([]);
    const panelSearchBox = ref<number | null>(0);
    const topMargin = ref<string>('0');

    const unWatchUiState = watch(
        useDisplayObj.name,
        () => {
            panelSearchBox.value = isMobile.value ? null : 0;
            topMargin.value = `${useUiStateObj.headerHeightPx}px`;
            resizeMap();
        },
        { immediate: true }
    );

    const mapDefaultHeight = '560px';
    const mapHeight = ref<string>(mapDefaultHeight);

    const searchObj = ref<LocationsMapSearch>(getPrePopSearch());
    const form = ref<LocationsMapSearch>(searchObj.value);

    const itemsRadius = ref<SelectListItem[]>([
        {
            text: '20',
            value: 20
        },
        {
            text: '50',
            value: 50
        },
        {
            text: '100',
            value: 100
        }
    ]);

    const itemsUnit = ref<SelectListItem[]>([
        {
            text: 'miles',
            value: 'mi'
        },
        {
            text: 'kilometers',
            value: 'km'
        }
    ]);

    async function getRetailLocations(): Promise<Location[] | void | Error> {
        const response = await useLocationsObj.getRetailLocations();

        if (lo_isError(response)) {
            return response;
        } else if (response && Array.isArray(response.data)) {
            return response.data;
        }
    }

    const {
        data: retailLocations
    } = useLazyAsyncData<Location[] | void | Error>(
        'keyRetailLocations',
        () => getRetailLocations(),
        {
            server: false
        }
    );

    let unWatchRetailLocations: WatchStopHandle;
    unWatchRetailLocations = watch(
        retailLocations,
        (newVal, oldVal) => {
            if (lo_isError(retailLocations.value)) {
                return;
            }

            if (newVal && !oldVal) {
                retailLocationsFiltered.value = retailLocations.value ?? [];
                unWatchRetailLocations?.();
            }
        },
        { immediate: true }
    );

    const unWatchSearchTerm = debouncedWatch(
        retailLocationsFilter,
        () => onFilterLocations(),
        { debounce: 500 }
    );

    const locationsCount = computed<number>(() => {
        if (Array.isArray(retailLocations.value)) {
            return retailLocations.value.length;
        }

        return 0;
    });

    const isFiltering = computed<boolean>(() => !!filteredLocationsCount.value && filteredLocationsCount.value < locationsCount.value);
    const filteredLocationsCount = computed<number>(() => retailLocationsFiltered.value.length);

    function resizeMap() {
        if (import.meta.client && isMobile.value) {
            requestAnimationFrame(() => {
                const box = elLocationsMap.value?.$el.getBoundingClientRect() ?? null;
                const offset = 20;

                if (!lo_isNil(box)) {
                    const winHeight = window.innerHeight;
                    mapHeight.value = `${winHeight - box.top - offset}px`;
                }
            });
        }
    }

    async function onSubmit(e: Event) {
        e.preventDefault();

        const validateObj = await elFormObj.value?.validate();

        if (validateObj.valid) {
            searchObj.value = lo_mergeCompat({}, searchObj.value, form.value);
            const { unit, location, radius } = searchObj.value;
            await navigateTo({ path: route.path, query: {
                u: unit, l: location, r: radius
            }, replace: true });
        }
    }

    function onReset(e: Event) {
        form.value = LocationsMapSearchModel.toPlainObject<LocationsMapSearch>();
        searchObj.value = LocationsMapSearchModel.toPlainObject<LocationsMapSearch>();
        boundLocationsUids.value = [];
        onFilterLocations();
        navigateTo({ path: route.path, query: {}, replace: true });
    }

    function locationItemClick(location: Location) {
        setTimeout(() => {
            elLocationsMap.value?.onOpenMarker(location);
        }, 10);
    }

    function showLocationSearchError() {
        createGlobalAlert({
            text: 'Could not find location specified. Please try again.',
            show: true,
            type: 'error'
        });
    }

    function toggleFullScreen() {
        isMapExpanded.value = !isMapExpanded.value;

        if (isMapExpanded.value) {
            mapHeight.value = '100%';
        } else if (isMobile.value && !isMapExpanded.value) {
            resizeMap();
        } else {
            mapHeight.value = mapDefaultHeight;
        }
    }

    function onFilterLocations(isLocationsSearch?: Nilish<boolean>): void {
        let locations: Nullable<Location[]> = [];

        if (!lo_isError(retailLocationsFilter.value) && Array.isArray(retailLocations.value)) {
            const term = retailLocationsFilter.value;
            const boundLen = boundLocationsUids.value.length;
            
            locations = retailLocations.value.filter((location: Location) => {
                const hasTerm = (term && term.length) ?
                    Boolean(location.address?.canonical?.match(new RegExp(term, 'i'))?.length) : true;
                const isBound = (boundLen) ?
                    boundLocationsUids.value.includes(location.uid) : true;
                return (hasTerm && isBound);
            });

            if (locations.length === retailLocations.value.length && isLocationsSearch) {
                locations = [];
            }
        }

        retailLocationsFiltered.value = locations;
    }

    function onBoundLocations(uids: Nilable<string[]>): void {
        boundLocationsUids.value = uids ?? [];
        onFilterLocations(true);
    }

    function getPrePopSearch(): LocationsMapSearch {
        const q = route.query;
        // TODO: Fix Type
        const obj = LocationsMapSearchModel.toPlainObject<any>();
        const radius = parseInt(getSingleParam(q, 'r') || obj.radius, 10) || 20;
        const location = getSingleParam(q, 'l') || obj.location;
        const unit = getSingleParam(q, 'u') || obj.unit;
        return Object.assign(obj, { radius, location, unit });
    }

    onBeforeMount(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((geolocation: GeolocationPosition) => {
                if (geolocation) {
                    searchObj.value.geolocation = geolocation;
                }
            });
        }
    });

    onBeforeUnmount(() => {
        unWatchUiState();
        unWatchSearchTerm();
        unWatchRetailLocations?.();
    });
</script>

<style lang="scss" scoped>
.list-retailers {
    margin: 0;
    padding: 0;

    .v-list-item {
        list-style: none;
        margin: 0;
        padding: 1rem 0.2rem;
        border-bottom: 1px solid rgb(var(--v-theme-accent-lighten-1));
    }
}

address {
    font-style: normal;
}

.action-buttons {
    gap: 1rem;
}

.show-list-btn {
    z-index: 1;
}

.store-locator-container {
    &.full-screen {
        background-color: rgb(var(--v-theme-surface));
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        width: 100%;
        height: 100vh;
        height: 100dvh;
        padding: 1rem;
    }
}

:deep(.v-navigation-drawer) {
    top: 0 !important;
    height: 100% !important;
}
</style>
